"use client";

import { useLocale } from "next-intl";
import { useEffect } from "react";

export default function AutoFontLoader() {
  const locale = useLocale();

  useEffect(() => {
    const font = locale === "ru" ? "robotoCondensed" : "heebo";
    document.body.setAttribute("font-family", font);
  }, [locale]);

  return null;
}
